import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";
import { SiteContentProvider } from "@/lib/site-content";

function App() {
  return (
    <div className="App">
      <SiteContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </SiteContentProvider>
    </div>
  );
}

export default App;
